import Constants from './Constants'

export default () => {
	let width = window.innerWidth

	if (width < Constants.breakpoints.sm) {
		return 'xs'
	} else if (width < Constants.breakpoints.md) {
		return 'sm'
	} else if (width < Constants.breakpoints.lg) {
		return 'md'
	} else if (width < Constants.breakpoints.xl) {
		return 'lg'
	} else if (width < Constants.breakpoints.xxl) {
		return 'xl'
	} else {
		return 'xxl'
	}
}
